// @ts-nocheck
/*
 * Port of views/dashboard/ivr/IVR/Helpers/IvrDrawer.js (28 lines).
 * BYTE-IDENTICAL — right-side portal drawer used by Answer/Webhook/etc.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { X } from 'lucide-react';

const IvrDrawer = ({
  show,
  onHide,
  title,
  subtitle,
  children,
  footer,
  width,
}: any) => {
  if (!show) return null;
  return ReactDOM.createPortal(
    <>
      <div className="ivr-drawer-backdrop" onClick={onHide} />
      <div className="ivr-drawer" style={width ? { width } : undefined}>
        <div className="ivr-drawer-header">
          <div className="ivr-drawer-header-text">
            <div className="ivr-drawer-title">{title}</div>
            {subtitle && <div className="ivr-drawer-subtitle">{subtitle}</div>}
          </div>
          <button className="ivr-drawer-close" onClick={onHide} title="Close">
            <X size={16} strokeWidth={2.5} />
          </button>
        </div>
        <div className="ivr-drawer-body">{children}</div>
        {footer && <div className="ivr-drawer-footer">{footer}</div>}
      </div>
    </>,
    document.body,
  );
};

export default IvrDrawer;
